import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent {
  IsMFAuser:boolean=false
  captchatext="";
  captcha=""
  constructor( public ref: DynamicDialogRef,private config:DynamicDialogConfig){
    this.getCaptcha();
     const dataFromParent = this.config.data;
     console.log(dataFromParent,"ismfenable");
     
     this.IsMFAuser=dataFromParent.IsMFAuser
  }
  isRotating = false;

    getCaptcha(){
  const alpha = [
  'A','B','C','D','E','F','G','H','I','J','K','L','M',
  'N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
  'a','b','c','d','e','f','g','h','i','j','k','l','m',
  'n','o','p','q','r','s','t','u','v','w','x','y','z',
  '0','1','2','3','4','5','6','7','8','9',
  '!','@','#','$','%','^','&','*','+'
];
 let a=alpha[Math.floor(Math.random()*71)];
 let b=alpha[Math.floor(Math.random()*71)];
 let c=alpha[Math.floor(Math.random()*71)];
 let d=alpha[Math.floor(Math.random()*71)];
 let e=alpha[Math.floor(Math.random()*71)];
 let f=alpha[Math.floor(Math.random()*71)];
 console.log(a+b+c+d+e+f);
 
 return this.captcha=a+b+c+d+e+f


  }

  onclose(){
    this.ref.close()
  }
invalid:boolean=false;
invalidcaptchamsg=""
  validate(){
    if(this.captchatext==""){
      this.invalid=true
      this.invalidcaptchamsg="Captcha is required"

    }
    else if(this.captcha!==this.captchatext){
            this.invalid=true;
                  this.invalidcaptchamsg="Invalid Captcha"


    }
   else if(this.captcha==this.captchatext){
      this.invalid=false
       this.ref.close("validcaptcha")


    }

  }
refresh(){
        this.invalid=false
        this.isRotating = true;

  setTimeout(() => {
    this.isRotating = false;
  }, 500); // animation duration
  this.getCaptcha()

}






}
